<div class="flex flex-col gap-6">
    <div class="flex items-center gap-4">
        <img src="/images/logo-manutencao.png" alt="Módulo em Construção" class="w-20 h-20 rounded-2xl" />

        <div class="flex flex-col">
            <h4 class="text-base font-bold text-white tracking-tight leading-tight">Módulo em Construção</h4>
            <div class="flex items-center gap-1.5 mt-1">
                <svg class="text-blue-400 animate-pulse" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
                </svg>
                <span class="text-[10px] text-blue-400 font-black uppercase tracking-[0.1em]"> Acesso em Breve </span>
            </div>
        </div>
    </div>

    <p class="text-sm text-slate-400 leading-relaxed font-medium">Estamos preparando novas funcionalidades para tornar a sua gestão ainda mais completa. Este módulo será otimizado para oferecer uma experiência ágil e intuitiva.</p>

    <div class="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>

    <div class="flex items-center gap-2.5 py-1">
        <svg class="text-slate-500" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
        <span class="text-[11px] font-bold text-slate-500 uppercase tracking-wider"> Previsão: Dezembro 2026 </span>
    </div>
</div>
